import { GetAddressData } from '@/services/api/map'

import { MixPanel } from '@/mixin/mixpanel'
import uniqBy from 'lodash/uniqBy'
import { Helper } from '@/mixin/helper'
import { getAddress, getGeolocation } from '@/services/api/geolocation'

export const state = {
  center: { lat: -2.958881, lng: 109.5543666 },
  zoom: 5.56,
  address: [],
  infoWindow: {
    position: { lat: 0, lng: 0 },
    open: false,
    address: '',
    detail: {
      currentGeofences: [],
      sensors: [],
      licensePlate: null,
      vehicle: {
        driver1: null,
        vehicleType: {
          icon: null,
        },
      },
      alert: {
        alertCode: 0,
        descriptionIdn: null,
      },
    },
    vehicle: null,
    type: 'fleet',
  },
  type: 'fleet',
  vehicleIds: [],
  pickedColumns: [],
  tracking: {
    param: 0,
    vehicleId: null,
  },
  modalFleetHistory: false,
  fleetsListMap: [],
  dosByFleetOrder: [],
  fleetOrder: null,
  modalFleetPlanning: false,
  modalRoutePlanning: false,
  fleetTabIndex: 0,
  gMapGenerate: 'Static',
}

export const actions = {
  setCENTER({ commit }, payload) {
    commit('CENTERING', payload)
  },
  setZOOM({ commit }, payload) {
    commit('ZOOM', payload)
  },
  closeInfo({ commit }, payload) {
    commit('CLOSE_INFO', payload)
  },
  modalFleetHistory({ commit }, payload) {
    commit('MODAL_HISTORY', payload)
  },
  setInfoWindow({ commit }, payload) {
    commit('SET_INFOWINDOW', payload)
  },
  async requestAddress({ commit }, payload) {
    const useCache = Helper.methods.isUsingCache()

    if (useCache) {
      const address = await getGeolocation({ lat: payload.lat, lon: payload.lng })
      const data = getAddress(address, payload.lat, payload.lng)?.name

      commit('SET_ADDRESS', data === '' ? '-' : data)
    } else {
      const address = await GetAddressData(payload.lat, payload.lng)

      commit('SET_ADDRESS', address.display_name)
    }
  },
  async setFleetInfo({ commit }, payload) {
    await commit('SET_FLEET_INFO', payload)
  },
  setDObyFleetOrder({ commit }, payload) {
    const dos = payload.map((v) => {
      return {
        id: v.id,
        number: v.number,
        status: v.status,
        customer: v.shipped_customer,
        fleet_task: v.fleet_task,
      }
    })
    commit('SET_DO_BY_FLEET_ORDER', dos)
  },
}

export const mutations = {
  CENTERING(state, payload) {
    if (payload.gmp) {
      state.center.lat = parseFloat(payload.gmp.latitude)
      state.center.lng = parseFloat(payload.gmp.longitude)
      state.zoom = payload.zoom
      state.infoWindow.open = payload.open
      state.infoWindow.position.lat = parseFloat(payload.gmp.latitude)
      state.infoWindow.position.lng = parseFloat(payload.gmp.longitude)
      if (payload.open) {
        state.infoWindow.detail = payload.gmp

        if (state.tracking.vehicleId != payload.gmp.vehicleId) state.tracking.param = 0
        state.tracking.vehicleId = payload.gmp.vehicleId

        if (payload.type === 'fleet' && state.tracking.param == 0) {
          const calculatedMotionStatus = payload.gmp.calculatedMotionStatus
          var status
          switch (calculatedMotionStatus) {
            case 'M':
              status = 'Moving'
              break
            case 'I':
              status = 'Idle'
              break
            case 'P':
              status = 'Parking'
              break
            case 'O':
              status = 'Offline'
          }
          MixPanel.methods.track('View Detail Fleet Information from Fleet List Panel Live View', {
            status: status,
          })
          state.tracking.param++
        } else if (payload.type === 'notif' && state.tracking.param == 0) {
          const alert = payload.gmp.alert
          var category
          if ([24, 23, 8].includes(alert.alertCode)) {
            category = 'driverBehaviour'
          } else if ([51, 52, 53, 54, 55, 56, 49, 110, 111, 50].includes(alert.alertCode)) {
            category = 'dms'
          } else if (
            [1, 11, 17, 18, 3, 10, 12, 7, 16, 15, 21, 22, 62, 63, 75, 104, 94, 95].includes(
              alert.alertCode
            )
          ) {
            category = 'general'
          } else if ([90, 91, 92, 113].includes(alert.alertCode)) {
            category = 'adas'
          }

          MixPanel.methods.track('View Notification Today', {
            category: category,
            type: alert.descriptionEng,
          })
          state.tracking.param++
        }
      }
      state.infoWindow.type = payload.type
    } else {
      state.infoWindow = {
        position: { lat: 0, lng: 0 },
        open: false,
        address: '',
        detail: {
          currentGeofences: [],
          vehicle: {
            driver1: null,
            vehicleType: {
              icon: null,
            },
          },
          alert: {
            alertCode: 0,
            descriptionIdn: null,
          },
        },
        vehicle: null,
      }

      state.infoWindow.type = payload.type

      state.center.lat = -2.958881
      state.center.lng = 109.5543666
      state.zoom = 5.56
      if (state.type === 'fleetOrder' || state.type === 'fleetInstant') {
        state.fleetOrder = null
        state.type = 'fleet'
      }
    }
  },
  ZOOM(state, payload) {
    if (payload.isZoom) {
      state.zoom = payload.zoom
    }
    state.center.lat = payload.lat
    state.center.lng = payload.lng
  },
  CLOSE_INFO(state, payload) {
    state.infoWindow.open = payload
  },
  MODAL_HISTORY(state, payload) {
    state.modalFleetHistory = payload
  },
  MODAL_FLEETPLANNING(state, payload) {
    state.modalFleetPlanning = payload
  },
  MODAL_ROUTEPLANNING(state, payload) {
    state.modalRoutePlanning = payload
  },
  SET_ADDRESS(state, payload) {
    state.infoWindow.address = payload
  },
  SET_ADDRESS_INFO(state, payload) {
    const data = {
      latitude: payload.latitude,
      longitude: payload.longitude,
      address: payload.address,
    }
    state.address = [...state.address, data]
  },
  RESET_ADDRESS_INFO(state) {
    state.address = []
  },
  // SET_ALL_ADDRESS (state, payload) {
  //   state.address = payload
  // },
  TYPE_OF_MAP(state, payload) {
    state.type = payload
  },
  SET_INFOWINDOW(state, payload) {
    if (state.infoWindow.open) {
      state.infoWindow.position = { lat: payload.latitude, lng: payload.longitude }
      state.infoWindow.type = payload.type
    }
  },
  TYPE_OF_MAP_INFOWINDOW(state, payload) {
    state.infoWindow = {
      position: { lat: 0, lng: 0 },
      open: false,
      address: '',
      detail: {
        currentGeofences: [],
        licensePlate: null,
        vehicle: {
          driver1: null,
          vehicleType: {
            icon: null,
          },
        },
        alert: {
          alertCode: 0,
          descriptionIdn: null,
        },
      },
      vehicle: null,
      type: payload,
    }
  },
  SET_VEHICLEIDS(state, payload) {
    state.vehicleIds = payload
  },
  SET_PICKED_COLUMNS(state, payload) {
    state.pickedColumns = payload
  },
  SET_FLEET_LIST_MAP(state, payload) {
    state.fleetsListMap = payload
  },
  SET_FLEET_INFO(state, payload) {
    if (payload) {
      state.infoWindow.detail = { ...state.infoWindow.detail, ...payload }
    } else {
      state.infoWindow = {
        position: { lat: 0, lng: 0 },
        open: false,
        address: '',
        detail: {
          currentGeofences: [],
          licensePlate: null,
          vehicle: {
            driver1: null,
            vehicleType: {
              icon: null,
            },
          },
          alert: {
            alertCode: 0,
            descriptionIdn: null,
          },
        },
        vehicle: null,
        type: 'fleet',
      }
    }
  },
  SET_DO_BY_FLEET_ORDER(state, payload) {
    if (!payload?.length) {
      state.dosByFleetOrder = []
      return
    }
    // Initialize
    if (state.dosByFleetOrder.length == 0) {
      state.dosByFleetOrder = payload
      return
    }
    // For load more data by scroll
    if (
      state.dosByFleetOrder[0].fleet_task.id === payload[0].fleet_task.id &&
      state.dosByFleetOrder[0].fleet_task.id
    ) {
      state.dosByFleetOrder = uniqBy(
        [...state.dosByFleetOrder, ...payload],
        (deliveryOrder) => deliveryOrder.id
      )
    } else {
      // Click other FO
      state.dosByFleetOrder = payload
    }
  },
  SET_ACTIVE_FO(state, payload) {
    state.fleetOrder = payload
  },
  setFleetTabIndex(state, payload) {
    state.fleetTabIndex = payload
  },
  setDefaultMap(state, payload) {
    state.gMapGenerate = payload
  },
}
